// extracted by mini-css-extract-plugin
module.exports = {"permission-management":"permission-management___3Wde_","permission-picker-modal":"permission-picker-modal___2j1x7"};